import { RoutedTabs } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'

export const ClubTopBarLayout = () => {
  const { t } = useTranslate()

  const tabs = [
    {
      value: 'benefits',
      label: t('clubPage_menu_invite'),
      href: '/club/invite',
    },
    {
      value: 'missions',
      label: t('clubPage_menu_missions'),
      href: '/club/missions',
    },
    {
      value: 'levels',
      label: t('clubPage_menu_rewards'),
      href: '/club/rewards',
    },
  ]
  return (
    <RoutedTabs
      tabs={tabs}
      defaultTab='benefits'
      size='lg'
      color='base'
      className='sticky md:relative gap-0 md:gap-2 top-0  '
    />
  )
}
